import React, { useRef } from 'react';
import { Spinner } from "react-bootstrap";
import { ReactComponent as PoweredBy } from "../../images/powered-by-scope.svg";
import { CSSTransition } from 'react-transition-group';

interface GamePreLoaderProps {
  isThemeLoaded: boolean;
}

const GamePreLoader: React.FC<GamePreLoaderProps> = ({ isThemeLoaded }) => {
  const nodeRef = useRef(null);

  return (
    <CSSTransition
      in={!isThemeLoaded}
      timeout={400}
      classNames="preloader"
      unmountOnExit
      nodeRef={nodeRef}
    >
      <div
        ref={nodeRef}
        className="game-preloader"
      >
        <div className="game-preloader__powered-by mb-3">
          <PoweredBy
            width={300}
            aria-label="Powered by"
            role="img"
          />
        </div>
        <div className="game-preloader__spinner">
          <Spinner
            aria-label="Loading"
            role="status"
          />
        </div>
      </div>
    </CSSTransition>
  );
};

export default React.memo(GamePreLoader);